import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Collapse, Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import './TwoFASettingsModal.css';
import QRCode from 'qrcode.react';
import IconContainer from '../../../commonComponents/iconContainer/IconContainer';
import FormWrapper from '../../../commonComponents/formWrapper/FormWrapper.container';

const ENABLE_2FA_SUCCESS_MESSAGE = "enable_2fa_success_message";
const DISABLE_2FA_SUCCESS_MESSAGE = "disable_2fa_success_message";

class TwoFASettingsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checkCode: "",
            isParametersCollapseOpen: false,
            isLinksCollapseOpen: false,
            successMessage: null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen && !this.props.isOpen && !nextProps.is2FAEnable) {
            this.props.onGenerate2FASecret();
        }

        if (nextProps.success && this.props.success !== nextProps.success) {
            this.setState({
                successMessage: this.props.is2FAEnable ? DISABLE_2FA_SUCCESS_MESSAGE : ENABLE_2FA_SUCCESS_MESSAGE
            })
        }

        if (nextProps.isOpen && !this.props.isOpen) {
            this.setState({
                checkCode: "",
                isParametersCollapseOpen: false,
                isLinksCollapseOpen: false,
                successMessage: null
            })
        }
    }

    render() {
        if (!_.isNil(this.state.successMessage)) {
            return (
                <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel} className="two-fa-settings-modal-container">
                    <ModalBody>
                        <h5 className="text-center two-fa-settings-label">{_.get(this.props.translation, 'security_settings.2fa_label')}</h5>
                        <h6>{_.get(this.props.translation, 'security_settings.' + this.state.successMessage)}</h6>
                        <div className="two-fa-modal-success-buttons-container">
                            <Button className="olive-green-btn" onClick={this.props.onCancel}>
                                {_.get(this.props.translation, sharedLabelsPath.okey_button)}
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>
            )
        }
        if (!_.isNil(this.props.is2FAEnable)) {
            return (
                <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel} className="two-fa-settings-modal-container">
                    <ModalBody>
                        <FormWrapper successMessage={_.get(this.props.translation, 'security_settings.' + (this.props.is2FAEnable ? "enable_2fa_success_message" : "disable_2fa_success_message"))}>
                            <h5 className="text-center two-fa-settings-label">{_.get(this.props.translation, 'security_settings.2fa_label')}</h5>
                            {this.renderContent()}
                            <div className="two-fa-modal-buttons-container">
                                <Button color="secondary" onClick={this.props.onCancel}>
                                    {_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                                </Button>
                                <Button className="olive-green-btn" onClick={this.onSubmit} disabled={this.props.loadingQRCodeData || this.checkCodeIsInvalid()}>
                                    {_.get(this.props.translation, 'security_settings.' + (this.props.is2FAEnable ? "disable_2fa_submit_button" : "enable_2fa_submit_button"))}
                                </Button>
                            </div>
                        </FormWrapper>
                    </ModalBody>
                </Modal>
            );
        } else {
            return null;
        }
    }

    checkCodeIsInvalid = () => this.state.checkCode.length < 6 && this.state.checkCode.length > 0;

    renderContent() {
        if (this.props.loadingQRCodeData) {
            return (
                <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
            )
        }
        if (this.props.is2FAEnable) {
            return (
                <div>
                    <h6>{_.get(this.props.translation, 'security_settings.disable_2fa_are_you_sure_message')}</h6>
                </div>
            )
        } else {
            if (!_.isNil(this.props.QRCodeData)) {
                return (
                    <div>
                        <h6>
                            {_.get(this.props.translation, 'security_settings.enable_2fa_scan_qr_code_message')}
                        </h6>
                        <h6 className="warning-message">
                            {_.get(this.props.translation, 'security_settings.update_warning')}
                        </h6>
                        {this.renderLinks()}
                        <div className="qr-code-container">
                            <QRCode
                                renderAs="svg"
                                size={200}
                                value={`otpauth://totp/BrainChain:${this.props.userEmail}?secret=${this.props.QRCodeData.secret}&issuer=BrainChain`}
                            />
                        </div>
                        <div>
                            {this.renderParameters()}
                        </div>
                        <h6>
                            {_.get(this.props.translation, 'security_settings.enable_2fa_check_code_message')}
                        </h6>
                        <FormGroup row>
                            <Label sm={4}>{_.get(this.props.translation, 'security_settings.check_code_label')}</Label>
                            <Col sm={8}>
                                <Input
                                    value={this.state.checkCode}
                                    onChange={this.handleChangeCheckCode}
                                    type="text"
                                    size="6"
                                    placeholder="_ _ _ _ _ _"
                                    invalid={this.checkCodeIsInvalid()}
                                />
                                <FormFeedback>{_.get(this.props.translation, 'security_settings.verification_code_details_label')}</FormFeedback>
                            </Col>
                        </FormGroup>
                    </div>
                )
            }
        }
    }

    renderLinks = () => {
        let iconName = "keyboard_arrow_" + (this.state.isLinksCollapseOpen ? "down" : "right");
        return (
            <div className="links-container">
                <div className="links-title-container olive-green">
                    <h6 onClick={this.toggleLinks}>{_.get(this.props.translation, 'security_settings.links_label')}</h6>
                    <IconContainer onClick={this.toggleLinks} className="links-title-icon" icon={iconName} />
                </div>
                <div className="links-details-container">
                    <Collapse isOpen={this.state.isLinksCollapseOpen}>
                        <div className="links-container">
                            <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
                                {_.get(this.props.translation, 'security_settings.google_authenticator_android_label')}
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://itunes.apple.com/us/app/google-authenticator/id388497605">
                                {_.get(this.props.translation, 'security_settings.google_authenticator_ios_label')}
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=org.fedorahosted.freeotp">
                                {_.get(this.props.translation, 'security_settings.free_otp_android_label')}
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://itunes.apple.com/ru/app/freeotp-authenticator/id872559395">
                                {_.get(this.props.translation, 'security_settings.free_otp_ios_label')}
                            </a>
                        </div>
                    </Collapse>
                </div>
            </div>
        )
    };

    renderParameters = () => {
        let iconName = "keyboard_arrow_" + (this.state.isParametersCollapseOpen ? "down" : "right");
        return (
            <div className="parameters-container">
                <div className="parameters-title-container olive-green">
                    <h6 onClick={this.toggleParams}>{_.get(this.props.translation, 'security_settings.enable_2fa_parameters_label')}</h6>
                    <IconContainer onClick={this.toggleParams} className="parameters-title-icon" icon={iconName} />
                </div>
                <div className="parameters-details-container">
                    <Collapse isOpen={this.state.isParametersCollapseOpen}>
                        <Row>
                            <Col sm={3}>
                                <h6>{_.get(this.props.translation, 'security_settings.issuer_label') + ":"}</h6>
                            </Col>
                            <Col sm={9}>
                                BrainChain
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={3}>
                                <h6>{_.get(this.props.translation, sharedLabelsPath.email_label) + ":"}</h6>
                            </Col>
                            <Col sm={9}>
                                {this.props.userEmail}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={3}>
                                <h6>{_.get(this.props.translation, 'security_settings.secret_label') + ":"}</h6>
                            </Col>
                            <Col sm={9}>
                                {this.props.QRCodeData.secret}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={3}>
                                <h6>{_.get(this.props.translation, 'security_settings.algorithm_label') + ":"}</h6>
                            </Col>
                            <Col sm={9}>
                                {this.props.QRCodeData.algorithm}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={3}>
                                <h6>{_.get(this.props.translation, 'security_settings.digits_label') + ":"}</h6>
                            </Col>
                            <Col sm={9}>
                                {this.props.QRCodeData.digits}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={3}>
                                <h6>{_.get(this.props.translation, 'security_settings.period_label') + ":"}</h6>
                            </Col>
                            <Col sm={9}>
                                {this.props.QRCodeData.period}
                            </Col>
                        </Row>
                    </Collapse>
                </div>
            </div>
        )
    };

    toggleParams = () => {
        this.setState({ isParametersCollapseOpen: !this.state.isParametersCollapseOpen });
    };

    toggleLinks = () => {
        this.setState({ isLinksCollapseOpen: !this.state.isLinksCollapseOpen });
    };

    handleChangeCheckCode = (e) => {
        let regexp = /^[0-9]{0,6}$/;
        let value = e.target.value;
        if (regexp.test(value)) {
            this.setState({ checkCode: value });
        }
    };

    onSubmit = () => {
        if (this.props.is2FAEnable) {
            this.props.onDisable2FA();
        } else {
            if (!_.isNil(this.state.checkCode) && this.state.checkCode.length === 6){
                this.props.onEnable2FA(this.state.checkCode);
            } else {
                this.props.onEnable2FA();
            }
        }

    };
}

TwoFASettingsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    is2FAEnable: PropTypes.bool,
    loadingQRCodeData: PropTypes.bool,
    QRCodeData: PropTypes.object,
    userEmail: PropTypes.string,
    success: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onGenerate2FASecret: PropTypes.func.isRequired,
    onEnable2FA: PropTypes.func.isRequired,
    onDisable2FA: PropTypes.func.isRequired
};

export default TwoFASettingsModal;



// WEBPACK FOOTER //
// ./src/components/accountManagement/securitySettings/twoFASettingsModal/TwoFASettingsModal.js